import React from "react";
import { FcGoogle } from "react-icons/fc";
import { Button } from "@chakra-ui/react";

interface GoogleButtonProps {
  onClick: () => void;
  href?: string;
  className?: string;
}

const GoogleButton: React.FC<GoogleButtonProps> = ({
  onClick,
  href,
  className,
}) => {
  return (
    <a href={href} className={className}>
      <Button
        className="w-full"
        fontSize="var(--base-font-size)"
        leftIcon={<FcGoogle />}
        variant="outline"
        onClick={onClick}
      >
        Continue with Google
      </Button>
    </a>
  );
};

export default GoogleButton;
